import React, { useEffect, useRef } from 'react';

/**
 * Composants FairViews pour afficher les avis clients
 * https://fairviews.com
 */

// Widget Combo - Section témoignages (page d'accueil, avant le footer)
export const FairViewsCombo = () => (
  <section style={{ 
    padding: '40px 20px', 
    textAlign: 'center', 
    background: '#f9fafb' 
  }}>
    <h2 style={{ 
      marginBottom: '20px', 
      fontSize: '24px', 
      color: '#1a1a1a' 
    }}>
      Ce que nos clients disent de nous
    </h2>
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <iframe 
        src="https://fairviews.com/api/widget/embed/combo/toilestorebanne.com" 
        width="620" 
        height="300" 
        frameBorder="0"
        style={{ border: 'none', maxWidth: '100%' }}
        title="Avis clients FairViews"
      />
    </div>
  </section>
);

// Widget Badge - Page panier/checkout (colonne de droite) - Version iframe
export const FairViewsBadge = () => (
  <iframe 
    src="https://fairviews.com/api/widget/embed/badge/toilestorebanne.com" 
    width="250" 
    height="200" 
    frameBorder="0"
    style={{ border: 'none' }}
    title="Avis clients FairViews"
  />
);

// Widget Badge avec script - Version pour la sidebar (remplace "Protection acheteur")
export const FairViewsBadgeWidget = () => {
  const containerRef = useRef(null);
  const scriptLoadedRef = useRef(false);

  useEffect(() => {
    // Configuration globale FairViews
    if (typeof window !== 'undefined') {
      window.FAIRVIEWS_WIDGET_URL = "https://fairviews.com";
      window.FAIRVIEWS_REVIEW_URL = "https://fairviews.com";
    }

    // Charger le script FairViews une seule fois
    if (!scriptLoadedRef.current) {
      const existingScript = document.querySelector('script[src="https://fairviews.com/api/widget/script.js"]');
      
      if (!existingScript) {
        const script = document.createElement('script');
        script.src = 'https://fairviews.com/api/widget/script.js';
        script.defer = true;
        script.async = true;
        document.body.appendChild(script);
      }
      
      scriptLoadedRef.current = true;
    }
  }, []);

  return (
    <div 
      ref={containerRef}
      id="fairviews-widget-badge"
      data-domain="toilestorebanne.com"
      data-testid="fairviews-sidebar-badge"
    />
  );
};

export default { FairViewsCombo, FairViewsBadge, FairViewsBadgeWidget };
